<template>
	<div class="main-cont">
		<div class="wrapper-back-ini">
			<h1 class="header-desc">{{ prega }}</h1>
		</div>
		<div class="wrapper-back-end">
			<h1 class="header-desc">{{ pregb }}</h1>
		</div>

		<div class="wrapper-back-img">
			<h1 class="header-desc">{{ pregc }}</h1>
			<img :src="block"/>
		</div>

		<div class="wrapper-cont">
			<div class="topend-cont">
				<div class="wrapper-item">
					<ItemCard v-for="i in probs" :data="i" :key="i.h" :head="i.h" :cont="i.c"/>
				</div>
			</div>
			
			<div class="middle-cont"/>

			<div class="topend-cont">
				<div class="wrapper-item">
					<ItemCard v-for="i in soluc" :data="i" :key="i.h" :head="i.h" :cont="i.c"/>
				</div>
			</div>
		</div>

		
	</div>
</template>

<script>
import ItemCard from './ItemCard.vue';

export default {
  name: 'Goals',
  components: 	{ItemCard},
  data () {
    return {
	    prega:	'¿Qué problemas busca resolver Electchain?',
	    pregb:	'¿Cuál es la propuesta de valor de Electchain?',
			pregc:	'',
			intro:	'¿Qué es electchain?',
			descr:	'Electchain es un proyecto de software mexicano construido sobre blockchain que responde a la necesidad de la sociedad ante la búsqueda de métodos alternativos para el conteo de votos decentralizado',
			probs: [
				{h: 'Fraude Electoral', c:'Una vez emitido el voto, éste no se podrá modificar por ningún medio'},
				{h: 'La transparencia', c:'Es subjetiva, ya que depende de las actividades de cada casilla. Dichas actividades no se veran comprometidas en el sistema'},
				{h: 'Intervencionismo', c:'Como iniciativa, nos compremetemos a no favorecer a ningún movimiento de campaña política'}
			],
			soluc: [
				{h:'Utilizar blockchain',c:'El uso de tecnología blockchain garantiza la integridad del estado de las votaciones'},
				{h:'Votar en internet',c:'Un proceso alternativo completamente transparente\n (El voto seguirá siendo libre y secreto)'}
			],
			block:	 require('./assets/blockchain.png'),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-cont{
	height: 100%;
	overflow: hidden;
	position: relative;
}

/*BACK PARTS*/
.wrapper-back-ini{
	position: absolute;
	z-index: 1;
	left: 0;
  width: 100%;
  height: 33%;
}
.wrapper-back-img{
	position: absolute;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	left: 0;
  width: 100%;
  height: 100%;
}
.wrapper-back-img > img{
	opacity: 0.25;
	max-width: 75%;
	max-height: 75%;
}
.wrapper-back-end{
	position: absolute;
	left: 0;
	bottom: 0;
  width: 100%;
  height: 33%;
}

/*FRONT PARTS*/
.wrapper-cont{
	height: 100%;
	position: relative;
	z-index: 1;
}
.wrapper-item{
	display: flex;
	align-items: center;
	justify-content: space-around;
	min-height: 240px;
  background-color: rgba(45, 89, 139, .5);
	width: 100%;
}
.topend-cont{
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 33.3%;
}
.middle-cont{
	height: 33.3%;
}

@media screen and (min-width: 480px) and (max-width: 820px){
  .wrapper-item{
    display: inline-flex;
		flex-direction: column;
		justify-content: space-between;
		height: 80%;
  }

	/*BACK PARTS*/
	.wrapper-back-ini{
	  height: 40%;
	}
	.wrapper-back-end{
	  height: 40%;
	}

	/*FRONT PARTS*/
	.topend-cont{
		align-items: flex-end;
		height: 40%;
	}
	.middle-cont{
		height: 20%;
	}
}

@media screen and (max-width: 480px){
  .wrapper-item{
    display: inline-flex;
		flex-direction: column;
		justify-content: space-between;
		height: 80%;
  }

	/*BACK PARTS*/
	.wrapper-back-ini{
	  height: 40%;
	}
	.wrapper-back-end{
	  height: 40%;
	}

	/*FRONT PARTS*/
	.topend-cont{
		align-items: flex-end;
		height: 40%;
	}
	.middle-cont{
		height: 20%;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/Goals.vue